import React, { useContext, useEffect, useLayoutEffect, useRef } from 'react';

import { createContext, useState } from 'react';
import * as _ from 'lodash';

const DropdownContext = createContext();

function DropdownProvider(props) {
  const {
    name,
    value,
    handleOnChange,
    listForceReload,
    callbackApi,
    responseKey = null,
    responseNestedKey = null,
    fieldName,
    fieldValue,
    isShowToolTip,
    label,
    children,
    filterResponse,
    isUseLoadMore = true,
    isSort = false,
    options = [],
  } = props;
  const [isShowDropdown, setIsShowDropdown] = useState(false);
  const [selected, setSelected] = useState(value);
  const [selectedName, setSelectedName] = useState(name);

  // state handle call api and load more data
  const [isLoading, setIsLoading] = useState(true);
  const [allLoaded, setAllLoaded] = useState(false);
  const [isInitial, setIsInitial] = useState(true);
  const [data, setData] = useState([]);

  const [searchName, setSearchName] = useState('');
  const targetId = useRef(`infinity-scroll-target-dropdown-${_.uniqueId()}`)
    .current;
  const isLoadMore = useRef(false);
  const decoratorRef = useRef(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setSelected(value);
    setSelectedName(value && name ? name : label);
  }, [value]);

  const handleDocumentClick = e => {
    if (dropdownRef.current && dropdownRef.current.contains(e.target)) {
      return;
    }
    if (decoratorRef.current && decoratorRef.current.contains(e.target)) {
      return;
    }
    setIsShowDropdown(false);
  };

  useLayoutEffect(() => {
    if (isShowDropdown) {
      document.addEventListener('click', handleDocumentClick);
    }
    return () => {
      if (isShowDropdown) {
        document.removeEventListener('click', handleDocumentClick);
      }
    };
  }, [isShowDropdown]);

  useEffect(() => setIsInitial(true), [listForceReload, searchName]);

  useEffect(() => {
    if (_.size(options) > 0) {
      setIsLoading(false);
      setAllLoaded(true);
      return setData(options);
    }
    if (isInitial && isShowDropdown) {
      setAllLoaded(false);
      setIsLoading(true);
      setData([]);
      setIsInitial(false);
      isLoadMore.current = false;
      fetchData();
    }
  }, [isShowDropdown, isInitial]);

  const handleToggleDropdown = () => {
    setIsShowDropdown(!isShowDropdown);
  };

  const handleSelectedRow = (value, checked) => {
    let val = null;
    let selectedRow = null;
    if (checked === true) {
      val = value;
      selectedRow = _.find(data, [fieldValue, value]);
    }
    setSelected(val);
    handleOnChange(selectedRow);
    setIsShowDropdown(false);
  };

  const fetchData = async (notify = () => {}) => {
    const params = {
      is_limit: 1,
      limit: 30,
      offset: isLoadMore.current ? _.size(data) : 0,
      name: searchName,
    };

    const response = await callbackApi(params);
    setIsLoading(false);
    if (!response) {
      return;
    }
    if (!response.result) {
      return;
    }
    let responseData;
    if (responseKey) {
      responseData = _.get(response, `data.entities.${responseKey}`, []);
    } else {
      responseData = _.get(response, `data.entities`, []);
    }

    const allLoaded = isUseLoadMore
      ? _.size(responseData) < params.limit
      : true;
    let options = isLoadMore.current ? data : [];
    _.each(responseData, record => {
      const index = _.findIndex(options, [
        fieldValue,
        responseNestedKey
          ? record[responseNestedKey][fieldValue]
          : record[fieldValue],
      ]);
      if (index === -1) {
        if (responseNestedKey) {
          options.push(record[responseNestedKey]);
        } else if (record[fieldValue]) {
          const templateName = record.template_name
            ? record.template_name
            : _.get(record, 'template.name');
          const isDuplicateNameFlag = record.duplicate_name_flag;
          if (fieldValue === 'sub_work_type_id') {
            let subWorkName = record.name;
            if (responseKey === 'works') {
              subWorkName = record.sub_work_type_name;
            }
            record['sub_work_type_name'] = isDuplicateNameFlag
              ? `${subWorkName}（${templateName}）`
              : subWorkName;
          } else {
            let mainWorkName = record.name;
            if (responseKey === 'works') {
              mainWorkName = record.main_work_type_name;
            }
            record['main_work_type_name'] = isDuplicateNameFlag
              ? `${mainWorkName}（${templateName}）`
              : mainWorkName;
          }
          if (fieldValue === 'category_code') {
            record['key_plan_name'] = `${record.label} : ${record.comment}`;
          }
          options.push(record);
        }
      }
    });
    if (filterResponse) {
      options = _.filter(options, filterResponse);
    }
    if (isSort) {
      options = _.orderBy(options, 'id', 'desc');
    }
    setData(options);
    setAllLoaded(allLoaded);
    isLoadMore.current = true;
    notify();
  };

  const handleOnChangeName = _.debounce(setSearchName, 1000);

  const handleClearSelectedRow = () => {
    setSelected(null);
    handleOnChange(null);
    handleToggleDropdown();
  };

  const handleInView = notify => {
    if (_.size(options) > 0) {
      return;
    }
    if (allLoaded) {
      return notify();
    }
    fetchData(notify);
  };
  const contextValue = {
    data,
    targetId, // id for handle load more data
    selected,
    isLoading,
    decoratorRef,
    isShowDropdown,
    selectedName,
    dropdownRef,
    setSelected,
    setSelectedName,
    fieldValue,
    fieldName,
    isShowToolTip,
    searchName,
    handleInView,
    handleToggleDropdown,
    handleSelectedRow,
    handleClearSelectedRow,
    handleOnChangeName,
    options,
  };

  return (
    <DropdownContext.Provider value={contextValue}>
      {children}
    </DropdownContext.Provider>
  );
}

const useDropdown = () => {
  const context = useContext(DropdownContext);
  if (typeof context === 'undefined') {
    throw new Error('useDropdown must be used within DropdownProvider');
  }
  return context;
};

export { useDropdown, DropdownProvider };



// WEBPACK FOOTER //
// ./src/components/dropdowns/portal/DropdownContext.js